<bspk-form-field [controlId]="controlId()" [errorMessage]="errorMessage()" [helperText]="helperText()" [label]="label()"
  [required]="required()">

  <!-- Trailing label -->
  @if (maxLength() !== null) {
  <span bspk-txt="body-small" data-label-trailing>
    {{ trailingLabel() }}
  </span>
  }

  <bspk-textarea [aria-label]="label()" [disabled]="disabled()" [errorMessage]="errorMessage()" [id]="controlId()"
    [invalid]="invalid()" [maxLength]="maxLength()" [maxRows]="maxRows()" [minRows]="minRows()"
    [placeholder]="placeholder()" [readOnly]="readOnly()" [required]="required()" [size]="size()" [value]="value()" (blur)="handleBlur($event)"
    (valueChange)="handleChange($event)" />

</bspk-form-field>
